<template lang="pug">
DocumentsBox(
  :filter="documentFilter",
  :upload-property="documentUploadProperty",
  :disabled="props.disabled",
  :max-width="props.maxWidth"
)
</template>

<script setup lang="ts">
import { computed } from "vue";
import DocumentsBox from "./DocumentsBox.vue";
import type { DocumentsSearch } from "../../services/documents";

const props = defineProps<{
  twinId: string;
  disabled?: boolean;
  maxWidth?: number | string;
}>();

const documentFilter = computed<DocumentsSearch>(() => ({
  category: "twinDocument",
  type: "document",
  entityType: "twin",
  entityId: props.twinId,
}));

const documentUploadProperty = computed<Record<string, string>>(() => ({
  category: "twinDocument",
  type: "document",
  entityType: "twin",
  entityId: props.twinId,
}));
</script>
